<template>
    <span data-component="showHideLink"
          class="show-hide-link"
          :class="{'show-hide-link--shown': show}"
          @click="$emit('update:showHide')">
        {{ show ? l('HIDE') : l('SHOW') }}
        <i class="fa-solid fa-chevron-down ml-025"></i>
    </span>
</template>

<script>

export default {
    name: 'ShowHideLink',

    props: {
        show: {
            type: Boolean,
            default: false,
        },
    },

    emits: [
        'update:showHide',
    ],
};
</script>

<style lang="less">
.show-hide-link {
    position: relative;
    top: 0;

    i {
        transition: transform 0.2s ease-out;
    }

    &--shown {
        // The same chevron is for show/hide and it rotates with an animation instead of just flipping.
        i {
            transform: rotate(180deg);
        }
    }
}
</style>
